export * from './module.service';
export * from './user.service';
export * from './account.service';
export * from './manager.service'
export * from './common.service'
export * from './site.service';
export * from './authentication.service';
export * from './user-module-role.service';
export * from './tenant.service';
export * from './loan.service';
export * from './custom-type.service';
export * from './guard.service';
export * from './department.service';
export * from './email.service';
export * from './type3.service';
export * from './type4.service';
export * from './summary.service';
export * from './settings.service';
export * from './issue.service';
export * from './issue-web.service';
export * from './issueType1Service';
export * from './issueType2Service';
export * from './customer.service';
export * from './company-type.service';
export * from './issue-recipient.service';
export * from './issue-type3.service';
export * from './activity.service';
export * from './report-type-shedule.service';
export * from './incident-accident-service.service';
export * from './contracts.service';
export * from './calendar.service';



// WEBPACK FOOTER //
// ./src/app/services/index.ts